export const GifImagesStyle = {
  width: "170px"
};

export const CHAT_FILE_CONTENT_TYPES = ["jpg", "jpeg", "gif", "png", "webp"];
export const GIPHGY = "giphy";
